import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function getAllFailure(draft: Draft<IProductData>) {
  draft.getAll.config.errorMessage = 'Não foi possível carregar os produtos';
  draft.getAll.config.isLoading = false;
}

export default getAllFailure;
